import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { Badge, Icon, Text } from '@/ui'
import { mtc, TextColors } from '@/styles'

interface GreetingBubbleProps {
  title: string
  message: string
  onDismiss: (e: React.MouseEvent) => void
}

/**
 * Tooltip-style speech bubble that appears above the ChatTrigger button
 * after a short delay. Dismissed on click (stored in localStorage by the
 * parent).
 */
export const GreetingBubble = ({
  title,
  message,
  onDismiss,
}: GreetingBubbleProps) => (
  // `pointer-events-auto` restores clicks that the positioning wrapper turns
  // off for its own empty space — see `ChatTrigger`.
  <div className="adviser-greeting-bubble pointer-events-auto">
    <button
      type="button"
      onClick={onDismiss}
      className={mtc(
        'absolute top-2 right-2',
        'flex items-center justify-center',
        'w-4 h-4',
        'bg-transparent text-neutral-400',
        'border-none cursor-pointer',
        'hover:text-neutral-600 transition-colors',
        'text-xs leading-none'
      )}
      aria-label="Dismiss"
    >
      <Icon icon={faXmark} />
    </button>
    <div className="m-0 mb-1 flex items-center gap-2 leading-snug">
      <Text color={TextColors.HEADER} className="text-sm font-extrabold">
        {title}
      </Text>
      <Badge
        variant="secondary"
        color="olive"
        size="sm"
        className="rounded-full py-0.5 text-xs font-bold"
      >
        New
      </Badge>
    </div>
    <Text color={TextColors.EMPHASIS} className="m-0 text-sm leading-snug">
      {message}
    </Text>
  </div>
)
